import React from 'react';

import { BaseIconProps } from './';

export const MinusCircle = ({ fill }: BaseIconProps) => (
  <g transform="matrix(63.529412,0,0,63.529412,-2e-6,-2e-6)">
    <circle cx="8.5" cy="8.5" r="8.5" fill={fill} />
    <path
      d="m 6,8.5 h 5"
      strokeWidth="2"
      stroke="white"
      strokeLinecap="square"
    />
  </g>
);
